function animateWrite(textObject) {
  const writer = setInterval(() => {
    const text = textObject.data;
    const index = textObject.charIndex;
    textObject.display += text[index];
    textObject.charIndex += 1;
    if (textObject.charIndex >= textObject.data.length) {
      clearInterval(writer);
    }
  }, 100);
}

export default animateWrite
